import React from 'react';
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';


const Cardicon = () => {

    const { t, i18n } = useTranslation();
    return (
        <div className={'row icon-boxes '} >
        <div className='col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0'>
          <div className='icon-box'>
            <div className='icon'><i className='bi bi-stack'></i></div>
            <h4 className='title'>{t('Performance_Speed')}</h4>
            <p className='description'>{t('Our_programs_and_products')}</p>
          </div>
        </div>
        <div className='col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0' >
          <div className='icon-box'>
            <div className='icon'><i  className='bi bi-palette' ></i></div>
            <h4 className='title'>{t('Design_qualit')}</h4>
            <p  className='description'>{t('The_style_of_the_programs')}</p>
          </div>
        </div>
        <div className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" >
          <div className="icon-box">
            <div className="icon"><i className="bi bi-shield-shaded"></i></div>
            <h4 className="title">{t('Safety_and_protection')}</h4>
            <p  className="description">{t('By_using_external_servers')}</p>
          </div>
        </div>
        <div className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" >
          <div className="icon-box">
            <div className="icon"><i className="bi bi-tools"></i></div>
            <h4 className="title">{t('After_sales_service')}</h4>
            <p  className="description">{t('It_would_be_nice')}</p>
          </div>
        </div>
        </div>
    
    )
}

export default Cardicon
